import React, {useEffect} from "react";
import useStyles from './styles'
import messages from './messages'
import {isNonEmpty} from '../../../../../shared/utils'
import useUploadHelper from "../../../../FileUploadHelper";


const DropZoneInput = ({ 
    fileTypes="application/pdf, image/jpeg, image/jpg, image/tiff, image/tif", 
    name, 
    onChange, 
    setBanner, 
    attachments=[], 
    uploadInfo, 
    headerProps, 
    enableModal=true, 
    disabled=false}) => {

    const _uploadInfo = useUploadHelper();
    const {
        DZone, 
        FileList, 
        Modal, 
        files, 
        isFileTooBig, 
        isTooManyFiles,
        fileContainsSpecialCharacter, 
        fileRejections = [],
        invalidFileTypes,
        setFiles,
        clearErrors,
        change: {operation} } = uploadInfo ? uploadInfo : _uploadInfo;
    const classes = useStyles()

    useEffect( () => {
        if( attachments && attachments.length !== files.length){
            setFiles({files: attachments})
        }
    // eslint-disable-next-line
    }, [])

    useEffect(() => {
      if (operation === "add" || operation === "remove") {
        if (onChange) {
          onChange({ target: { name, value: files } });
        }
      }
      if (operation === "add") {
        setBanner({
          severity: "success",
          message: "Document(s) Attached Successfully",
        });
      }
      // eslint-disable-next-line
    }, [files]);

    useEffect(() => {
      let error = null;
      if (isFileTooBig) {
        error = messages.fileTooBig;
      } else if (isTooManyFiles) {
        error = messages.tooManyFiles;
      } else if (fileContainsSpecialCharacter) {
        error = messages.fileContainsSpecialCharacter;
      } else if (invalidFileTypes) {
        error = messages.fileRejections;
      }
      //    if (operation === "rejected") {
      //     if (fileRejections.length > 0 && "errors" in fileRejections[0]) {
      //           setBanner({
      //             severity: "error",
      //             message: fileRejections[0].errors.message || 'Error',
      //           });
      //        }
      //     }
      if (setBanner && isNonEmpty(error)) {
        setBanner({ severity: "error", message: error });
        clearErrors();
      }

      // eslint-disable-next-line
    }, [
      isFileTooBig,
      isTooManyFiles,
      fileContainsSpecialCharacter,
      invalidFileTypes,
    ]);

    return (
        <div id='MEDCAL_RX_DZONE_INPUT' className={classes.root}>
            <DZone id='MEDCAL_RX_DZONE' {...headerProps} disabled={disabled} accept={fileTypes} />
            <FileList disabled={disabled} id='MEDCAL_RX_FILELIST' />
            <Modal open={enableModal && !disabled}/>
        </div>
    )
}

export default DropZoneInput;
